const FontsExceptionsFoundationsThemes = {
    font_exception_size_paragraph_dot: '0.75rem',
    font_exception_line_height_paragraph_dot: '1rem',
    font_exception_weight_paragraph_dot: '37.5rem',
    font_exception_weight_paragraph_avatar_l: '25rem',
    font_exception_size_paragraph_avatar_l: '1.75rem',
    font_exception_size_paragraph_avatar_ms: '1.5rem',
    font_exception_size_paragraph_input_currency: '3.25rem',
    font_exception_line_height_paragraph_avatar_l: '2rem',
    font_exception_line_height_paragraph_avatar_ms: '2rem',
    font_exception_line_height_paragraph_input_currency: '4.6875rem',
    font_exception_weight_paragraph_avatar_ms: '25rem',
    font_exception_weight_paragraph_input_currency: '37.5rem',
};
export { FontsExceptionsFoundationsThemes };
//# sourceMappingURL=fonts-exceptions-foundations.themes.js.map